import { FILTER } from "app/const";
import { TipoFilterEnum } from "enums/tipo-filter.enum";
import { LocalFilter } from "./local-filter.model";
import {toBinaryStr} from "app/commons/toBinaryStr";

export class AppFilter {

    constructor(tipoFilter: TipoFilterEnum = TipoFilterEnum.TODOS, setAppFilterStorage = true) {
        // ao criar novo campo sempre inserir o mesmo neste método
        if (setAppFilterStorage) this.setAppFilterStorage(tipoFilter);
    }

    // filtros
    str1: string;
    str2: string;
    str3: string;
    str4: string;
    str5: string;
    str6: string = null;
    data1: Date;
    data2: Date;
    data3: Date;
    listNumber: number[];

    n1: number;
    n2: number;
    n3: number;
    n4: number;
    flag1: boolean;
    flag2: boolean;

    // paginacao
    page: number;
    size: number = 10;
    totalRows: number;


    // ordenacao
    sortBy: string;
    sortAsc: boolean = true;

    encode(): string {
        return btoa(encodeURIComponent(toBinaryStr(JSON.stringify(this))).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode(parseInt(p1, 16));
            }
        ));
    }

    private setAppFilterStorage(tipoFilter: TipoFilterEnum) {
        let filterLocalStorage: Array<LocalFilter> = JSON.parse(sessionStorage.getItem(FILTER));

        if (!filterLocalStorage)
            return

        filterLocalStorage.forEach(local => {
            let filterStorage: AppFilter = local.appFilter;
            if (local.tipoFilter == tipoFilter && filterStorage) {
                if (filterStorage.str1)
                    this.str1 = filterStorage.str1;

                if (filterStorage.str2)
                    this.str2 = filterStorage.str2;

                if (filterStorage.str3)
                    this.str3 = filterStorage.str3;

                if (filterStorage.str4)
                    this.str4 = filterStorage.str4;

                if (filterStorage.str5)
                    this.str5 = filterStorage.str5;

                if (filterStorage.str6)
                    this.str6 = filterStorage.str6;

                if (filterStorage.data1)
                    this.data1 = filterStorage.data1;

                if (filterStorage.data2)
                    this.data2 = filterStorage.data2;

                if (filterStorage.n1)
                    this.n1 = filterStorage.n1;

                if (filterStorage.n2)
                    this.n2 = filterStorage.n2;

                if (filterStorage.n3)
                    this.n3 = filterStorage.n3;

                if (filterStorage.n4)
                    this.n4 = filterStorage.n4;

                if (filterStorage.flag1)
                    this.flag1 = filterStorage.flag1;

                if (filterStorage.flag2)
                    this.flag2 = filterStorage.flag2;

                if (filterStorage.page)
                    this.page = filterStorage.page;
                else
                    this.page = 0;

                if (filterStorage.size)
                    this.size = filterStorage.size;

                if (filterStorage.sortAsc)
                    this.sortAsc = filterStorage.sortAsc;
                else
                    this.sortAsc = undefined;

                if (filterStorage.totalRows)
                    this.totalRows = filterStorage.totalRows;

                if (filterStorage.sortBy)
                    this.sortBy = filterStorage.sortBy;
                else
                    this.sortBy = undefined;

                return;
            }
        });
    }

}
